import { render, staticRenderFns } from "./RouteView.vue?vue&type=template&id=2dfe52be&scoped=true&"
import script from "./RouteView.vue?vue&type=script&lang=js&"
export * from "./RouteView.vue?vue&type=script&lang=js&"
import style0 from "./RouteView.vue?vue&type=style&index=0&id=2dfe52be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfe52be",
  null
  
)

export default component.exports